import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./styles.scss";
import { FaInstagram, FaWhatsapp, FaYoutube,FaTelegramPlane } from "react-icons/fa";
import Brand from "../../assets/img/logo-horizontal.png";

export default function Footer() {
  return (
    <>
      <div className="main-footer bg-primary">
        <Container fluid>
          <Row className="pt-4 justify-content-center">
            <Col xs={6} md="auto" className="d-flex justify-content-center justify-content-md-start">
              <img src={Brand} alt="logo" height="48px" />
            </Col>
            <Col md="auto" style={{ color: 'white' }}>
              <h5 style={{ color: 'white' }}>Quem somos</h5>
              <p>Somos uma comunidade que nasceu com a missão de fazer você, consumidor brasileiro, economizar em suas compras!</p>
              <p>Compartilhamos diariamente produtos com as melhores promoções das principais lojas do Brasil.</p>
            </Col>
            <Col xs={6} md="auto">
              <h5 className="text-white">Menu</h5>
              <div><Link to="/entrar" className="text-md-left">Entrar</Link></div>
              <div><Link to="/sobre">Caçadores de Ofertas</Link></div>
              <div><Link to="/contato">Contato</Link></div>
              
            </Col>
            
           
            <Col xs={6} md="auto" className="mt-md-2 order-md-1">
              <h5 className="text-white">Suporte</h5>
              <div className="suporte">
                <a href="mailto:@cacadoresdeofertas1@gmail.com">cacadoresdeofertas1@gmail.com</a>
              </div>
            </Col>
            
          </Row>
          <Row className="justify-content-center justify-content-md-end">
                <Col xs="auto">
                  <a
                    href="https://instagram.com/cacadores.ofertas"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram className="p-2 social-links" size="48" />
                  </a>
                </Col>
                <Col xs="auto">
                  <a
                    href="https://chat.whatsapp.com/IPrFvbirmIzIz35CzCzi08"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaWhatsapp className="p-2 social-links" size="48" />
                  </a>
                </Col>
                <Col xs="auto">
                  <a
                    href="https://www.youtube.com/@cacadoresofertas"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaYoutube className="p-2 social-links" size="48" />
                  </a>
                </Col>
                <Col xs="auto">
                  <a
                    href="https://t.me/s/cacadoresofertas"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaTelegramPlane className="p-2 social-links" size="48" />
                  </a>
                </Col>
              </Row>
          <hr className="bg-white" />

          <Row className="justify-content-between">
            <Col xs="auto" className="text-white">
              {`© Caçadores de Ofertas ${new Date().getFullYear()}. Todos os direitos reservados.`}
            </Col>
            <Col xs="auto">
              <Link to="/politica-privacidade">Termos e condições</Link>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

